export const isMacOS = () => navigator.appVersion.indexOf('Mac') !== -1
